import * as React from 'react';
import { PageProps, HeadFC } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';
import Layout from '@/components/layout/layout';
import Seo from '@/components/seo/seo';
import AppItem from '@/components/app-item/app-item';
import UseCaseItem from '@/components/use-case/use-case-item';
import HeroSection from '@/components/hero-section/hero-section';
import VideoSection from '@/components/video-section/video-section';
import BuildingDiagram from '../components/building-diagram/building-diagram';
import FlowDiagram from '@/components/flow-diagram/flow-diagram';
import {
  AppItemProps,
  AppSectionProps,
  UseCaseItemProps,
  DataTooltipProps
} from '@/types';
import { useApp } from '@/hooks/useApp';
import { useDevices } from '@/hooks/useDevices';
import { useUseCase } from '@/hooks/useUseCase';
import { useFlow } from '@/hooks/useFlow';
import { useStyles } from '@/hooks/useStyles';
import { classNames } from 'primereact/utils';

const IndexPage: React.FC<PageProps> = ({ location }) => {
  const { joinClasses } = useStyles();
  const appItems: Array<{ excerpt: string; section: AppSectionProps }> =
    useApp();
  const useCases: Array<{ excerpt: string; section: UseCaseItemProps }> =
    useUseCase();
  const devices: Array<DataTooltipProps> = useDevices();
  const items: Array<DataTooltipProps> = useFlow();

  const desktopClasses = {
    appSection: classNames('lg:grid-cols-2'),
    useCasesSection: classNames('lg:grid-cols-2 lg:gap-6')
  };
  const mobileClasses = {
    appSection: classNames('wrapper mt-[4.38rem] mb-8 grid grid-cols-1 gap-12'),
    useCasesSection: classNames(
      'wrapper mt-[4.38rem] mb-8 grid grid-cols-1 gap-6'
    )
  };

  return (
    <Layout location={location}>
      <HeroSection />
      <section className="wrapper mt-[4.38rem] mb-8 grid grid-cols-2 gap-6">
        <FlowDiagram items={items} />
      </section>
      <VideoSection />
      <section className="wrapper mt-[4.38rem] mb-8 grid grid-cols-2 gap-6">
        <BuildingDiagram items={devices} />
      </section>
      <section
        className={joinClasses([
          desktopClasses.appSection,
          mobileClasses.appSection
        ])}
      >
        {appItems.map(({ section, excerpt }, i) => {
          const app: AppItemProps = {
            cover: getImage(section.cover),
            altCover: section.title,
            logo: section.logo,
            altLogo: section.title,
            goTo: section.goTo,
            excerpt
          };
          return <AppItem key={i} data={app} />;
        })}
      </section>
      <section
        className={joinClasses([
          desktopClasses.useCasesSection,
          mobileClasses.useCasesSection
        ])}
      >
        {useCases.map(({ excerpt, section }, i) => {
          const useCase: UseCaseItemProps = {
            backgroundImage: section.backgroundImage,
            title: section.title,
            goTo: section.goTo,
            excerpt
          };
          return <UseCaseItem key={i} data={useCase} />;
        })}
      </section>
    </Layout>
  );
};

export const Head: HeadFC<{ title: string }> = () => <Seo title="Home" />;
export default IndexPage;
